import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../../../core/api/api.service';
import { API_HOST } from '../../../../core/api/api.config';
import { ENDPOINTS } from '../../../../core/api/endpoints';
import {
  MonitoringClientDto,
  MonitoringItemDto,
  SaveMonitoringPayload,
} from '../models/monitoring.model';

/** Monitoring APIs of crdt-prpsl-servc, rooted at `/mntrng`. */
@Injectable({ providedIn: 'root' })
export class MonitoringService {
  constructor(private api: ApiService) {}

  /** POST /mntrng/save-mntrng — creates or updates monitoring items for a client. */
  saveMonitoring(payload: SaveMonitoringPayload): Observable<any> {
    return this.api.post(API_HOST.monitoring, ENDPOINTS.MONITORING.SAVE_MNTRNG, payload);
  }

  /** GET /mntrng/get-pending-mntrng/{clntSeq} — items still open. */
  getPendingMonitoring(clntSeq: number): Observable<MonitoringItemDto[]> {
    return this.api.get<MonitoringItemDto[]>(
      API_HOST.monitoring,
      `${ENDPOINTS.MONITORING.GET_PENDING_MNTRNG}${clntSeq}`,
    );
  }

  /**
   * GET /mntrng/get-new-findings/{clntSeq}/{year} — findings already recorded
   * for that client in that calendar year.
   */
  getNewFindings(clntSeq: number, year: number): Observable<MonitoringItemDto[]> {
    return this.api.get<MonitoringItemDto[]>(
      API_HOST.monitoring,
      `${ENDPOINTS.MONITORING.GET_NEW_FINDINGS}${clntSeq}/${year}`,
    );
  }

  /** GET /mntrng/get-prev-mntrng/{clntSeq} — the previous year's monitoring items. */
  getPreviousMonitoring(clntSeq: number): Observable<MonitoringItemDto[]> {
    return this.api.get<MonitoringItemDto[]>(
      API_HOST.monitoring,
      `${ENDPOINTS.MONITORING.GET_PREV_MNTRNG}${clntSeq}`,
    );
  }

  /** GET /mntrng/clients — every client with its monitoring records nested. */
  getMonitoringClients(): Observable<MonitoringClientDto[]> {
    return this.api.get<MonitoringClientDto[]>(
      API_HOST.monitoring,
      ENDPOINTS.MONITORING.GET_CLIENTS,
    );
  }

  /** GET /mntrng/get-all-mntrng/{clntSeq} — every monitoring record of that client. */
  getAllMonitoring(clntSeq: number): Observable<MonitoringItemDto[]> {
    return this.api.get<MonitoringItemDto[]>(
      API_HOST.monitoring,
      `${ENDPOINTS.MONITORING.GET_ALL_MNTRNG}${clntSeq}`,
    );
  }
}
